import * as styles from "/tools/js/svg/templates/svg.module.scss";
const SvgLabel = ({ title, titleId, ...props }) => {
  props = Object.assign({}, props, {
    "aria-hidden": true,
  });
  if (!props.noAlign) {
    const className = (props.className || "") + " " + styles.alignIcon;
    props = Object.assign({}, props, {
      className,
    });
  }
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={20}
      height={20}
      viewBox="0 0 20 20"
      aria-labelledby={titleId}
      {...props}
    >
      {title ? <title id={titleId}>{title}</title> : null}
      <path
        fill="currentColor"
        d="M7.753 6.823a.927.927 0 0 0-.93-.929.927.927 0 0 0-.929.93c0 .515.414.929.93.929.515 0 .929-.414.929-.93Zm7.747 4.183a.935.935 0 0 1-.269.653l-3.565 3.572a.935.935 0 0 1-1.314 0l-5.191-5.198C4.79 9.67 4.5 8.965 4.5 8.45V5.43c0-.509.421-.93.93-.93h3.02c.515 0 1.22.29 1.59.66l5.191 5.185a.966.966 0 0 1 .269.66Z"
      />
    </svg>
  );
};
export default SvgLabel;
